<template>
    <div class="bonus">
		<div class="page-title">Бонусы</div>
		<ul class="bonus__tabs tabs" role="tablist">
			<li class="tabs__item" :class="currentTab === 'daily' ? 'active': ''" @click="currentTab = 'daily'">Бонусы</li>
			<li class="tabs__item" :class="currentTab === 'freespins' ? 'active': ''" @click="currentTab = 'freespins'">Фриспины</li>
			<li class="tabs__item" :class="currentTab === 'promocode' ? 'active': ''" @click="currentTab = 'promocode'">Промокод</li>
		</ul>
		<div class="bonus__content">
			<div class="bonus__cols" v-if="currentTab === 'daily'">
				<div class="bonus__col">
					<!-- daily bonus -->
					<div class="bonus__item">
						<div class="bonus__item-main">
							<svg class="bonus__item-icon">
								<use href="#svg-icon-mines-gift"></use>
							</svg>
							<div class="bonus__item-content">
								<div class="bonus__item-title">Подарок дня</div>
								<div class="bonus__item-text">Каждый день</div>
							</div>
							<button v-if="!is_weekly || bonusCountdown" class="bonus__item-action" :disabled="bonusCountdown" @click="getPromoSocket">
								<template v-if="bonusCountdown">

									<span class="bonus__item-action-value">Дo получения бонуса осталось</span>
									<span class="bonus__item-action-text">{{countdown}}</span>
								</template>
								<template v-else>
									<span class="bonus__item-action-value">до 10₽</span>
									<span class="bonus__item-action-text">Получить</span>
								</template>
							</button>
						</div>
					</div>
					<!-- week bonus -->
					<div class="bonus__item">
						<div class="bonus__item-main">
							<svg class="bonus__item-icon">
								<use href="#svg-icon-gift-ten"></use>
							</svg>
							<div class="bonus__item-content">
								<div class="bonus__item-title">Подарок недели</div>
								<div class="bonus__item-text">Каждую субботу</div>
							</div>
							<button v-if="is_weekly && !bonusCountdown" class="bonus__item-action" :disabled="bonusCountdown" @click="getPromoSocket">
								<template v-if="bonusCountdown">

									<span class="bonus__item-action-value">До получения бонуса осталось</span>
									<span class="bonus__item-action-text">{{countdown}}</span>
								</template>
								<template v-else>
									<span class="bonus__item-action-value">до 100₽</span>
									<span class="bonus__item-action-text">Получить</span>
								</template>
							</button>
						</div>
					</div>
					<!-- rakeback -->
					<div class="bonus__item">
						<div class="bonus__item-main">
							<svg class="bonus__item-icon">
								<use href="#svg-icon-rakeback"></use>
							</svg>
							<div class="bonus__item-content">
								<div class="bonus__item-title">Рейкбек
									<span class="bonus__item-note">
										<Informer >
											Каждый вторник вы можете забрать свои накопленные бонусы рейкбека. Рейкбек начисляется с каждой вашей ставки за предыдущие 7 дней и зависит от вашего ранга.
											<span v-if="rakeback">Сумма ваших ставок с <span class="white-100">{{ rakeback.start }} по {{ rakeback.end }}: {{ $root.currency(rakeback.profit) }}</span><br>
												Информация актуальна на: <span class="font-weight-bold">{{ user.profit_calculated_at }}</span>
											</span>
										</Informer>
									</span>

								</div>
								<div class="bonus__item-text">Каждый вторник</div>
							</div>
							<button class="bonus__item-action"
									:disabled="!rakeback || !rakeback.is_available"
									@click="takeRakeback">
								<template v-if="!rakeback || !rakeback.is_available">
									<span class="bonus__item-action-value">Для получения рейбека осталось</span>
									<span class="bonus__item-action-text">{{ rakebackCountdown}}</span>
								</template>
								<template v-else>
									<span class="bonus__item-action-value">{{ $root.currency(rakeback ? rakeback.amount : 0) }}</span>
									<span class="bonus__item-action-text">Получить</span>
								</template>
							</button>
						</div>
					</div>
					<!-- cashback -->
					<div class="bonus__item">
						<div class="bonus__item-main">
							<svg class="bonus__item-icon">
								<use href="#svg-icon-cashback"></use>
							</svg>
							<div class="bonus__item-content">
								<div class="bonus__item-title">Кешбек
									<span class="bonus__item-note" >
									<Informer>
										Каждый <span class="font-weight-bold">понедельник</span> и <span class="font-weight-bold">четверг</span> вы можете забрать свои накопленные бонусы кешбека. Кешбек начисляется на отрицательный профит за предыдущие дни и зависит от вашего ранга.<br />
										В <span class="font-weight-bold">понедельник</span> вы можете забрать кешбек, который был накоплен с <span class="font-weight-bold">четверга</span> по <span class="font-weight-bold">воскресенье</span>.<br />
										В <span class="font-weight-bold">четверг</span> вы можете забрать кешбек, который был накоплен с <span class="font-weight-bold">понедельника</span> по <span class="font-weight-bold">среду</span>.<br />
										<span v-if="cashback">
											Ваш профит с <span class="font-weight-bold">{{ cashback.start }}</span> по <span class="font-weight-bold">{{ cashback.end }}</span>: <span class="font-weight-bold">{{ $root.currency(cashback.profit) }}</span><br />
											Информация актуальна на: <span class="font-weight-bold">{{ user.profit_calculated_at }}</span>
										</span>
									</Informer>
								</span>
								</div>
								<div class="bonus__item-text">Каждый понедельник и четверг</div>
							</div>
							<button class="bonus__item-action"
									:disabled="!cashback || !cashback.is_available"
									@click="takeCashback">
								<template v-if="!cashback || !cashback.is_available">
									<span class="bonus__item-action-value">До получения кешбека осталось</span>
									<span class="bonus__item-action-text">{{ cashbackCountdown}}</span>
								</template>
								<template v-else>
									<span class="bonus__item-action-value">{{ $root.currency(cashback ? this.cashback.amount : 0) }}</span>
									<span class="bonus__item-action-text">Доступно к снятию</span>
								</template>
							</button>
						</div>
					</div>
				</div>
				<div class="bonus__col">
					<!-- subscribes vk -->
					<div class="bonus__item bonus__item--vk">
						<div class="bonus__item-main">
							<svg class="bonus__item-icon">
								<use href="#svg-icon-vk"></use>
							</svg>
							<div class="bonus__item-content">
								<div class="bonus__item-title">Амбассадор ВКонтакте</div>
								<div class="bonus__item-text">Выполни квесты и получи бонусы</div>
							</div>
							<button class="bonus__item-action"
									:disabled="hasSubscribeVK"
									@click="subscribeVk">
								<template v-if="hasSubscribeVK">
									<span class="bonus__item-action-value">Бонус активирован</span>
								</template>
								<template v-else>
									<span class="bonus__item-action-value">2₽</span>
									<span class="bonus__item-action-text">Получить</span>
								</template>
							</button>
						</div>
						<div class="bonus__check-items">
							<div class="bonus__check-item" :class="{active: hasSubscribeVK}">
								<svg class="bonus__check-item-icon">
									<use :href="`#svg-icon-${hasSubscribeVK ? 'checked' : 'unchecked'}`"></use>
								</svg>
								<span class="bonus__check-item-text">Подпишись на <a class="bonus__check-item-link" :href="$root.$link.vk" target="_blank">группу ВК</a></span>
								<span class="bonus__check-item-value">2₽</span>
							</div>
							<div class="bonus__hr"></div>
							<div class="bonus__check-item">
								<svg class="bonus__check-item-icon">
									<use href="#svg-icon-unchecked"></use>
								</svg>
								<span class="bonus__check-item-text">Репостни
									<a class="bonus__check-item-link" target="_blank" href="https://vk.com/boomx_casino?w=wall-224510226_6">этот пост</a>
									<div class="bonus__item-text">Пост должен быть закреплён 7 дней на странице вашего открытого профиля</div>
								</span>
								<span class="bonus__check-item-value">25₽</span>
							</div>
							<div class="bonus__check-item"  :class="{active: user?.vkontakte}">
								<svg class="bonus__check-item-icon">
									<use :href="`#svg-icon-${user?.vkontakte ? 'checked' : 'unchecked'}`"></use>
								</svg>
								<span class="bonus__check-item-text">Привяжи
									<a class="bonus__check-item-link" @click="getBonusForLink('vkontakte')" href="#">Вконтакте</a>
								</span>
								<span class="bonus__check-item-value">1₽</span>
							</div>
							<div class="bonus__check-item">
								<svg class="bonus__check-item-icon">
									<use href="#svg-icon-unchecked"></use>
								</svg>
								<span class="bonus__check-item-text">Дополнительные репосты</span>
								<span class="bonus__check-item-value">по 0.4₽</span>
							</div>
						</div>
					</div>
					<!-- subscribes tg -->
					<div class="bonus__item">
						<div class="bonus__item-main">
							<svg class="bonus__item-icon">
								<use href="#svg-icon-tg"></use>
							</svg>
							<div class="bonus__item-content">
								<div class="bonus__item-title">Амбассадор в Telegram</div>
								<div class="bonus__item-text">Выполни квесты и получи бонусы</div>
							</div>
							<button class="bonus__item-action"
									:disabled="hasSubscribeTg"
									@click="subscribeTg">
								<template v-if="hasSubscribeTg">
									<span class="bonus__item-action-value">Бонус активирован</span>
								</template>
								<template v-else>
									<span class="bonus__item-action-value">2₽</span>
									<span class="bonus__item-action-text">Получить</span>
								</template>
							</button>
						</div>
						<div class="bonus__check-items">
							<div class="bonus__check-item" :class="{active: hasSubscribeTg}">
								<svg class="bonus__check-item-icon">
									<use :href="`#svg-icon-${hasSubscribeTg ? 'checked' : 'unchecked'}`"></use>
								</svg>
								<span class="bonus__check-item-text">Подпишись на <a class="bonus__check-item-link" :href="$root.$link.tg" target="_blank">Telegram канал</a></span>
								<span class="bonus__check-item-value">2₽</span>
							</div>
							<div class="bonus__hr"></div>
							<div class="bonus__check-item"  :class="{active: user?.telegram}">
								<svg class="bonus__check-item-icon">
									<use :href="`#svg-icon-${ user?.telegram ? 'checked' : 'unchecked'}`"></use>
								</svg>
								<span class="bonus__check-item-text">Привяжи
									<a class="bonus__check-item-link" @click="getBonusForLink('telegram')" href="#">Telegram</a>
								</span>
								<span class="bonus__check-item-value">1₽</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="bonus__freespins freespins" v-if="currentTab === 'freespins'">
				<div class="empty-message" v-if="!freespins.length">
					У вас нет активных фриспинов
					<div class="empty-message__subtitle" v-if="freespin">
						Каждую пятницу вы можете получить фриспины в случае, если отрицательный профит с <span class="white-100">{{ freespin.start }}</span> по <span class="white-100">{{ freespin.end }}</span> превысит -5000 рублей.
						Ваш текущий профит: <span class="white-100">{{ $root.currency(freespin.profit) }}</span>
					</div>
				</div>
				<div class="freespins__items" v-if="freespins">
					<div class="freespins__item" v-for="freespin in freespins">
						<div class="freespins__item-banner">
							<img class="freespins__item-banner-img" :src="freespin.game_image" alt="">
						</div>
						<div class="freespins__item-body">
							<svg class="freespins__item-icon">
								<use href="#svg-icon-slots"></use>
							</svg>
							<div class="freespins__item-content">
								<div class="freespins__item-name">{{ freespin.game_name }}</div>
								<div class="freespins__item-text">
									Осталось <span class="white-100">{{ freespin.quantity_left }}</span> спинов по <span class="white-100">{{ freespin.bet_amount }} ₽</span>
								</div>
								<div class="freespins__item-note">
									Активно до {{ $root.moment(freespin.valid_until).format('DD-MM-YYYY, HH:mm') }}
								</div>
							</div>
							<router-link class="btn freespins__action"  :to="{name: 'slotsGame', params: { gameId: freespin.game_id }}">
								Играть
							</router-link>
						</div>
					</div>
				</div>
			</div>
			<div class="bonus__cols bonus__col--promo" v-if="currentTab === 'promocode'">
				<div class="bonus__col bonus__col--auto">
					<div class="bonus__promocode">
						<div class="bonus__promocode-field field-input">
							<input autocomplete="off" class="field-input__input" type="text"
								   v-model="promocode" placeholder="Введите промокод">
						</div>
						<div class="bonus__promocode-field">
							<vue-recaptcha
								cssClass="bonus__recaptcha"
								:sitekey="$root.$reCaptchaSiteKey"
								ref="recaptcha"
								@verify="onCaptchaVerified"
								@expired="onCaptchaExpired">
							</vue-recaptcha>
						</div>
						<div class="bonus__promocode-field">
							<button class="btn btn--block" @click="actPromoSocket" :disabled="disableBtnSetPromo">Активировать</button>

							<a class="btn btn--block" v-if="nevk" :href="$root.$link.vk" target="_blank">
								<svg class="btn__icon">
									<use href="#svg-icon-vk"></use>
								</svg>
								<span>Перейти в группу</span>
							</a>
						</div>
					</div>
				</div>
				<div class="bonus__col bonus__col--short">
					<PromocodeActivations/>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
    import VueRecaptcha from './../../components/googlerecaptcha/GoogleReCaptcha.vue';
	import Informer from "../../components/blocks/Informer.vue";
	import PromocodeActivations from './PromocodeActivations.vue';

	import { mapState } from 'pinia';
	import { useUserStore } from './../../stores/User';

    const TYPE_FREESPIN = 'freespin';

    export default {
        components: {
			Informer,
            VueRecaptcha,
			PromocodeActivations
        },
        data() {
            return {
                daily_bonus: false,
                nevk: false,
                cashback: null,
                rakeback: null,
                freespins: [],
                freespin: null,
                hasSubscribeVK: false,
                hasSubscribeTg: false,
                needSubscribeVK: false,
                needSubscribeTg: false,
                disableBtnGetPromo: false,
                promocode: '',
                disableBtnSetPromo: false,
                gRecaptchaResponse: null,
				bonusCountdown: null,
                countdown: {},
				currentTab: 'daily',
				is_weekly: false,
				cashbackCountdown: null,
				cashbackInterval: null,
				rakebackCountdown: null,
				rakebackInterval: null,
				dailyBonusInterval: null
            }
        },
        mounted() {
            this.$root.isLoading = true;

            if (!this.$cookie.get('token')) {
                this.$root.isLoading = false;

                this.$toast.error('Требуется авторизация');

                return this.$router.go(-1);
            }

			this.getBonusInfo();
        },

		computed: {
			...mapState(useUserStore, ['user'])
		},

        methods: {
            getBonusForLink(provider) {
                if (provider == 'vkontakte' && this.user?.vkontakte) {
                    return this.$toast.error("Вы уже получали данный бонус");
                }
                if (provider == 'telegram' && this.user?.telegram) {
                    return this.$toast.error("Вы уже получали данный бонус");
                }

                this.$root.OAuth(provider);
            },
            getPromoSocket() {
                if (this.disableBtnGetPromo) {
                    return;
                }

				this.disableBtnGetPromo = true;
				
				this.$root.axios.post('/api/bonus/daily')
					.then(res => {
						const data = res.data;

						if (data.success) {
							this.$toast.success(data.message);

							this.user.balance += data.amount;

							this.daily_bonus = data.daily_bonus;
							this.bonusCountdown = data.bonus_countdown;

							if (this.bonusCountdown) {
								this.dailyBonusInterval = setInterval(this.dailyBonusTimer, 1000);
							}

							this.dailyBonusTimer();
						} else {
							this.$toast.error(data.message);

							this.disableBtnGetPromo = false;
						}
					}).catch(error => {
						this.$toast.error(this.$root.graphql.axiosGetError(error));

						this.disableBtnGetPromo = false;
					});
            },
            takeCashback() {
                this.$root.axios.post('/api/bonus/cashback/take')
                .then(res => {
                    const data = res.data;

                    if(data.success) {
                        this.cashback = data.info;
                        this.user.balance += data.amount;

                        this.$toast.success(data.message);
                    } else {
                        this.$toast.error(data.message);
                    }
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
            takeRakeback() {
                this.$root.axios.post('/api/bonus/rakeback/take')
                .then(res => {
                    const data = res.data;

                    if(data.success) {
                        this.rakeback = data.info;
                        
                        this.user.balance += data.amount;

                        this.$toast.success(data.message);
                    } else {
                        this.$toast.error(data.message);
                    }
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
            subscribeVk() {
                this.$root.axios.post('/api/bonus/subscribe/vk')
                .then(res => {
                    const data = res.data;

                    if(data.success) {
                        this.hasSubscribeVK = true;
                        this.user.balance = data.balance;

                        this.$toast.success(data.message);
                    } else {
                        this.$toast.error(data.message);
                    }
                }).catch(error => {
                    var message = this.$root.graphql.axiosGetError(error);
                    if (message === "Требуется привязанный аккаунт VK") {
                        this.needSubscribeVK = true;
                        this.$root.OAuth('vkontakte');
                    }
                    this.$toast.error(message);
                });
            },
            subscribeTg() {
                this.$root.axios.post('/api/bonus/subscribe/tg')
                .then(res => {
                    const data = res.data;

                    if(data.success) {
                        this.hasSubscribeTg = true;
                        this.user.balance = data.balance;

                        this.$toast.success(data.message);
                    } else {
                        this.$toast.error(data.message);
                    }
                }).catch(error => {
                    var message = this.$root.graphql.axiosGetError(error);

                    if (message === "Требуется привязанный аккаунт Telegram") {
                        this.needSubscribeTg = true;
                        this.$root.OAuth('telegram');

                    }
                    this.$toast.error(message);
                });
            },
            actPromoSocket() {
                if (!this.gRecaptchaResponse) {
                    return this.$toast.error('Необходимо пройти капчу');
                }

                if (this.disableBtnSetPromo) {
                    return;
                }

				this.disableBtnSetPromo = true;
				
				this.$root.axios.post('/api/bonus/promo', {
					code: this.promocode,
					recaptcha: this.gRecaptchaResponse
				}).then(res => {
					const data = res.data;

					if (data.success) {
						if (data.type === TYPE_FREESPIN) {
							this.getBonusInfo();
						}

						this.$toast.success(data.message);
						this.$root.emitter.emit('promocode.activated');
						this.user.balance = data.balance;
					} else {
						if (data.message === "Вы не состоите в группе") {
							this.nevk = true;
						}

						this.$toast.error(data.message);
					}

					this.disableBtnSetPromo = false;
				}).catch(error => {
					this.$toast.error(this.$root.graphql.axiosGetError(error));

					this.disableBtnSetPromo = false;
				});

				this.onCaptchaExpired();
            },
            getBonusInfo() {
                this.$root.axios.get('/api/bonus/info')
                .then(res => {
					const data = res.data;

					this.daily_bonus = data.daily_bonus;
                    this.cashback = data.cashback;
                    this.rakeback = data.rakeback;
                    this.freespins = data.freespins;
                    this.freespin = data.freespin;
					this.is_weekly = data.is_weekly;
					this.bonusCountdown = data.bonus_countdown;

                    this.hasSubscribeTg = data.has_subscribe_tg;
                    this.hasSubscribeVK = data.has_subscribe_vk;

                    this.dailyBonusTimer();

					if (this.bonusCountdown) {
						this.dailyBonusInterval = setInterval(this.dailyBonusTimer, 1000);
					}
					if (this.rakeback?.countdown) {
						this.rakebackInterval = setInterval(this.rakebackTimer, 1000);
					}
					if (this.cashback?.countdown) {
						this.cashbackInterval = setInterval(this.cashbackTimer, 1000);
					}

                    this.$root.isLoading = false;
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
            dailyBonusTimer() {
				if (!this.bonusCountdown) {
					clearInterval(this.dailyBonusInterval);
					return
				}
				this.countdown = this.getFormattedTime(this.bonusCountdown);
				--this.bonusCountdown;
            },

			rakebackTimer() {
				if (!this.rakeback.countdown) {
					clearInterval(this.rakebackInterval);
					return
				}
				this.rakebackCountdown = this.getFormattedTime(this.rakeback.countdown);
				--this.rakeback.countdown;
			},

			cashbackTimer() {
				if (!this.cashback.countdown) {
					clearInterval(this.cashbackInterval);
					return
				}
				this.cashbackCountdown = this.getFormattedTime(this.cashback.countdown);
				--this.cashback.countdown;
			},
			getFormattedTime(time) {
				return time ? `
					${Math.floor(time / 60 / 60 / 24) ? Math.floor(time / 60 / 60 / 24) + 'д ' : ''}
					${Math.floor(time / 60 / 60) ? Math.floor(time / 60 / 60) + 'ч ' : ''}
					${Math.floor(time / 60) % 60 ? Math.floor(time / 60) % 60 + 'м ' : ''}
					${Math.floor(time) % 60 + 'c'}
				` : null;
			},
            onCaptchaVerified(response) {
                this.gRecaptchaResponse = response;
            },
            onCaptchaExpired() {
                this.$refs.recaptcha.reset()
            }
        }
    }
</script>